import * as React from "react";
import { KeyboardKey } from "../browser/keyboard";

interface keyDownBinding {
  keyName: KeyboardKey;
  onKeyDown: () => void;
}

/**
 *
 * Hook for binding a behavior to a key.
 *
 * Right now this only supports binding keydown actions,
 * but it would be reasonable to extend this hook to handle
 * any desired keyboard action
 *
 * @param isActive: because this is a hook, we can't conditionally
 * call this function. However, we can pass `isActive`, and the keybinding will
 * only run if `isActive` is true.
 */
export const useKeyboardAction = ({
  keyDownBindings,
  isActive = true,
}: {
  keyDownBindings: keyDownBinding[];
  isActive?: boolean;
}) => {
  React.useEffect(() => {
    if (!isActive) {
      return;
    }
    const keyDownHandler = ({ key }: { key: string }) => {
      keyDownBindings.forEach(keyDownBinding => {
        if (key === keyDownBinding.keyName) {
          keyDownBinding.onKeyDown();
        }
      });
    };
    // Add escape key listener
    window.addEventListener("keydown", keyDownHandler);
    // removes listeners on cleanup
    return () => {
      window.removeEventListener("keydown", keyDownHandler);
    };
  }, [isActive, keyDownBindings]);
};
